/*
 * Policy service
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2021 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'app/shared/config/constants';
import { Policy } from 'app/shared/models';

@Injectable ( {
  providedIn: 'root'
} )
export class PolicyService {

  readonly url = Constants.policyServiceUrl;

  constructor( private http: HttpClient ) {
  }

  find( dateOfLoss: string, lineOfBusiness: string, jurisdiction: string ): Observable<Policy[]> {
    const params = new HttpParams ()
      .append ( 'pageNumber', 1 )
      .append ( 'pageSize', 50 )
      .append ( 'jurisdiction', jurisdiction )
      .append ( 'lineOfBusiness', lineOfBusiness )
      .append ( 'effectiveDate', dateOfLoss );

    return this.http.get<Policy[]> ( this.url, { params } );
  }
}
